import { render, staticRenderFns } from "./contactGuide.vue?vue&type=template&id=0a48b496&scoped=true"
import script from "./contactGuide.vue?vue&type=script&lang=js"
export * from "./contactGuide.vue?vue&type=script&lang=js"
import style0 from "./contactGuide.vue?vue&type=style&index=0&id=0a48b496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48b496",
  null
  
)

export default component.exports